module.exports = __webpack_public_path__ + "static/adjustable-bed-frame-fabric-84f402fffdcee756d52e92d3106ea0f0.mp4";